import React, { useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useTranslation } from 'next-i18next';
import { crashLatest, CrashLatestGameItem } from '@/apis/casino/crash';
import { useQuery } from '@tanstack/react-query';
import { floorToN } from '@/components/features/casino/crash/GameBox/utils';
import dayjs from 'dayjs';

const RoundHistoryTable: React.FC = () => {
  const rows: CrashLatestGameItem[] = [
    {
      result: '1.1409827933324452',
      hash: 'de1fd1e02aecb7489484fb23552a095ef106b596a5c0f5c85956d72599bb4cec',
      seed: '00000000000000000000f3ae6f26a5082c6d39e4009819ad53522c51517e7f1d',
      id: '253838',
      roundId: '215258',
      startTime: '2023-11-15 09:13:22',
    },
    {
      result: '1.770230044017033',
      hash: '8f2af7201824ed9b0ddd13e6120f6f9da0d69cac115960528c6a7097aa5ec443',
      seed: '00000000000000000000f3ae6f26a5082c6d39e4009819ad53522c51517e7f1d',
      id: '253837',
      roundId: '215257',
      startTime: '2023-11-15 09:12:59',
    },
    {
      result: '1.0091196968302965',
      hash: 'fb264ba632a0315b55a1df30996440026b1dca1cc74c984354411d0318cfbea8',
      seed: '00000000000000000000f3ae6f26a5082c6d39e4009819ad53522c51517e7f1d',
      id: '253836',
      roundId: '215256',
      startTime: '2023-11-15 09:12:45',
    },
    {
      result: '2.4186680714299347',
      hash: '68c8f221385cbbdd8dfaa630ad0427ef2cad88480b4c9f06cdae004fbfa8e82c',
      seed: '00000000000000000000f3ae6f26a5082c6d39e4009819ad53522c51517e7f1d',
      id: '253835',
      roundId: '215255',
      startTime: '2023-11-15 09:12:17',
    },
    {
      result: '2.424578981012091',
      hash: '68878c8925f47a01ef4a9703e638e16eaefcd704a9e00bb2481f0e8d515ec348',
      seed: '00000000000000000000f3ae6f26a5082c6d39e4009819ad53522c51517e7f1d',
      id: '253834',
      roundId: '215254',
      startTime: '2023-11-15 09:11:48',
    },
  ];

  const [list, setList] = useState<CrashLatestGameItem[]>([...rows]);
  const { t } = useTranslation();

  const { isLoading, error } = useQuery({
    queryKey: ['CrashLatestFive'],
    queryFn: async () =>
      crashLatest({
        page: 1,
        pageSize: 5,
      }),
    onSuccess: (res) => {
      if (res.status.code === '0') {
        setList(res.data.games);
      }
    },
  });

  return (
    <>
      <TableContainer component={Box}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>{t('Date/Time')}</TableCell>
              <TableCell align="left">{t('Result')}</TableCell>
              <TableCell align="left">{t('Round')}</TableCell>
              <TableCell align="left">{t('Hash')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {list.map((row) => (
              <TableRow key={row.id}>
                <TableCell
                  sx={{ whiteSpace: 'no-wrap' }}
                  component="th"
                  scope="row"
                >
                  {dayjs(row.startTime).format('MMMM D YYYY h:mm A')}
                </TableCell>
                <TableCell align="left">
                  x{floorToN(Number(row.result), 2)}
                </TableCell>
                <TableCell align="left">{row.roundId}</TableCell>
                <TableCell align="left">{row.hash}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default RoundHistoryTable;
